import { Storage } from '@lightningjs/sdk';

const TEST_KEY = 'storage';
const TEST_VALUE = 'item';

const expirationTimestamp = Date.now() + 365 * 24 * 60 * 60 * 1000;
const maxExpirationTimestamp = 2147483647000;

const expirationDate = shouldExpire => (shouldExpire ? expirationTimestamp : maxExpirationTimestamp);

class LightningSdkStorage {
  constructor() {
    this._storage = Storage;
  }

  getItem(key) {
    const { value = null, expires = null } = this._storage.get(key) || {};
    const currentTime = Date.now();

    if (expires && currentTime > expires) {
      this._storage.remove(key);

      return null;
    }

    return value;
  }

  getItems(keys = []) {
    return keys.reduce((acc, key) => {
      const value = this.getItem(key);

      return { ...acc, [key]: value };
    }, {});
  }

  setItem(key, value, expire = true) {
    const newStorageItem = {
      value,
      expires: expirationDate(expire),
    };
    this._storage.set(key, newStorageItem);

    return value;
  }

  setItems(items = {}, expire) {
    Object.keys(items).forEach(key => {
      this.setItem(key, items[key], expire);
    });

    return items;
  }

  removeItem(key) {
    this._storage.remove(key);

    return null;
  }

  clear() {
    this._storage.clear();

    return null;
  }
}

export const isStorageSupported = storage => {
  try {
    storage.setItem(TEST_KEY, TEST_VALUE);
    const storageItem = storage.getItem(TEST_KEY);
    storage.removeItem(TEST_KEY);

    return storageItem === TEST_VALUE;
  } catch (e) {
    throw new Error(e);
  }
};

export const platformStorage = new LightningSdkStorage();
